import { Col, Divider, Row } from 'antd'
import LeftArrow from 'assets/icons/LeftArrow'
import Avatar from 'components/Avatar'
import Button from 'components/Button'
import Flex from 'components/Flex'
import AlarmBlue from 'components/icons/AlarmBlue'
import Assignment from 'components/icons/Assignment'
import AutoMode from 'components/icons/AutoMode'
import CalendarYellow from 'components/icons/CalendarYellow'
import ControlIcon from 'components/icons/ControlIcon'
import EventBlue from 'components/icons/EventBlue'
import ScheduleinterviewIcon from 'components/icons/ScheduleInterviewIcon'
import RoutePath from 'components/route_path/RoutePath'
import CustomSteps from 'modules/DriveDetails/Style/CustomSteps'
import DateAndTimeSelection from 'modules/DriveDetails/Style/DateAndTimeSelection'
import PreviewDrawer from 'modules/DriveDetails/Style/PreviewDrawer'
import { PopupModel } from 'modules/DriveDetails/Style/SelectionStyle'
import {
  Address,
  BoxText,
  CalenderCard,
  CompanyRequest,
  Instruct,
  InstructionName,
  LeftAlignCol,
  LeftSection,
  Location,
  Name,
  Name1,
  NameAdd,
  NameNew,
  PaddedDivider,
  PaddedDivider1,
  PaddingRow,
  RoleNameDiv,
  RoleNameFlex,
  SectionName,
  SectionWrapper,
  StageName,
  StageType,
  StyleLeft,
  TopHeader,
  VerticalDivider,
  YellowBox,
  YellowBoxNew,
} from 'modules/DriveDetails/Style/style'
import {
  getNotificationCatalogues,
  sendInAppNotification,
  sendNotificationBulkEmailWhatsapp,
  sendNotificationEmail,
} from 'modules/ManageProfile/actions'
import {
  ButtonDiv,
  // FileTextSpan,
  FileInfoDiv,
  ResultDiv,
  ResultIconDiv,
  UploadMsgFlex,
} from 'modules/OfferLetter/Style/style'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useParams } from 'react-router-dom'
import { toCamelCase } from 'utils/camelCase'
import { permittedEventCruds } from 'utils/permissionsValidation'

const DriveDetails = ({
  getDriveDetails,
  getSingleRoleDetails,
  drivesDetail,
  viewRoleDetails,
  getStudentData,
  studentDetails,
  DriveDateSelection,
  ResheduleDriveDate,
  permissions,
}) => {
  const params = useParams()
  const [drawer, setDrawer] = useState(false)
  const [currentProcess, setCurrentProcess] = useState()
  const dispatch = new useDispatch()
  const [completedStep, setCompletedStep] = useState()
  const [completStedepStatus, setCompletStedepStatus] = useState()
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [changeDate, setChangeDate] = useState(false)
  let stdData = useSelector(state => state?.studentData?.studentDetails)
  const [slotWhatsappOnline, setSlotWhatsappOnline] = useState(null)
  const [slotWhatsappOffline, setSlotWhatsappOffline] = useState(null)
  const [slotEmailOnline, setSlotEmailOnline] = useState(null)
  const [slotEmailOffline, setSlotEmailOffline] = useState(null)
  const permittedEvents = permittedEventCruds(permissions, 'DRIVE')

  const interviewSlot =
    permittedEvents?.find(item => item.events?.eventName === 'ACTION')
      ?.events || ''

  useEffect(() => {
    ;(async () => {
      if (interviewSlot?.id) {
        let responce = await dispatch(
          getNotificationCatalogues(interviewSlot?.id)
        )
        const filteredArray = responce?.CatalogueData?.filter(
          item =>
            item.eventNotificationTemplate &&
            item.eventNotificationTemplate.templateName ===
              'interview_slot_selected_online' &&
            item.eventNotificationTemplate.eventNotificationType &&
            item.eventNotificationTemplate.eventNotificationType.name ===
              'WhatsApp'
        )

        if (filteredArray?.length > 0) {
          setSlotWhatsappOnline(filteredArray[0].eventNotificationTemplate)
        }

        const filteredArray1 = responce?.CatalogueData?.filter(
          item =>
            item.eventNotificationTemplate &&
            item.eventNotificationTemplate.templateName ===
              'interview_slot_selected_offline' &&
            item.eventNotificationTemplate.eventNotificationType &&
            item.eventNotificationTemplate.eventNotificationType.name ===
              'WhatsApp'
        )

        if (filteredArray1?.length > 0) {
          setSlotWhatsappOffline(filteredArray1[0].eventNotificationTemplate)
        }

        const filteredArray2 = responce?.CatalogueData?.filter(
          item =>
            item.eventNotificationTemplate &&
            item.eventNotificationTemplate.templateName ===
              'Interview Slot Reserved (Online)' &&
            item.eventNotificationTemplate.eventNotificationType &&
            item.eventNotificationTemplate.eventNotificationType.name ===
              'E-Mail'
        )

        if (filteredArray2?.length > 0) {
          setSlotEmailOnline(filteredArray2[0].eventNotificationTemplate)
        }

        const filteredArray3 = responce?.CatalogueData?.filter(
          item =>
            item.eventNotificationTemplate &&
            item.eventNotificationTemplate.templateName ===
              'Interview Slot Reserved (Offline)' &&
            item.eventNotificationTemplate.eventNotificationType &&
            item.eventNotificationTemplate.eventNotificationType.name ===
              'E-Mail'
        )

        if (filteredArray3?.length > 0) {
          setSlotEmailOffline(filteredArray3[0].eventNotificationTemplate)
        }
      }
    })()

    return () => {
      // this now gets called when the component unmounts
    }
  }, [interviewSlot])
  useEffect(() => {
    getDriveDetails(params.RoleID, params.DriveID)
  }, [])
  useEffect(() => {
    getSingleRoleDetails(params.DriveID, params.RoleID)
  }, [])
  useEffect(() => {
    getStudentData()
  }, [])
  useEffect(() => {
    if (drivesDetail?.candidateInterviewDetails?.length != 0) {
      drivesDetail?.candidateInterviewDetails?.map((item, index) => {
        if (
          item?.interview?.interviewRound ===
          viewRoleDetails?.role?.driveRoleCandidateMap?.[0]?.stage
        ) {
          setCurrentProcess(item)
        }
      })
    } else {
      setCurrentProcess({})
    }
  }, [drivesDetail, viewRoleDetails])

  useEffect(() => {
    let data = viewRoleDetails?.role?.driveRoleCandidateMap?.[0]?.stage
    setCompletStedepStatus(
      viewRoleDetails?.role?.driveRoleCandidateMap?.[0]?.status
    )
    let index = viewRoleDetails?.role?.interviewWorkFlow?.rounds?.findIndex(
      x => x.name === data
    )
    setCompletedStep(index)
  }, [viewRoleDetails])

  const stepsData1 = viewRoleDetails?.role?.interviewWorkFlow?.rounds?.map(
    (round, index) => {
      return {
        key: index,
        activeKey: index,
        roundNumber: `Round ${index + 1}`,
        roundName: round?.name,
      }
    }
  )

  const CheckIcon = logo => {
    if (logo === null) {
      return (
        <Avatar
          background
          size={64}
          IconName={viewRoleDetails?.role?.corporate?.name[0]}
          font={18}
        />
      )
    } else {
      return <Avatar size={64} src={logo} />
    }
  }
  const getDriveMode = driveMode => {
    return driveMode?.toLowerCase().replace('_', ' ')
  }
  const openLink = () => {
    window.open(`${currentProcess?.link}`, '_blank', 'noreferrer')
  }

  const typeLabels = {
    ASSESMENT: 'Assessment',
    GROUP: 'Group Discussion',
    FACE_TO_FACE: 'Interview',
  }
  const labelText = typeLabels[currentProcess?.interview?.interviewType] || ''
  const messageType = toCamelCase(labelText)
  const selectDriveDate = async data => {
    let payload = {
      selectedDate: data?.date,
      selectedTime: data?.time,
      candidateStatus: 'CONFIRMED',
      corporateStatus: 'CONFIRMED',
    }
    const result = await DriveDateSelection(currentProcess?.id, payload)
    if (result?.status >= 200 && result?.status <= 300) {
      let InAppObj = {
        notification: {
          students: [
            {
              ids: [stdData?.id],
              userIds: [],
              roles: ['Student'],
              issuer: 'student',
              createFor: 'student',
              inApp: true,
              body: `Your selected interview slot for the ${viewRoleDetails?.role?.tittle} position at ${viewRoleDetails?.role?.corporate?.name} is confirmed`,
              tag: 'Interview',
            },
          ],
        },
      }
      dispatch(sendInAppNotification(InAppObj))
      if (slotEmailOnline && currentProcess?.mode === 'EXTERNAL_LINK') {
        let template
        template = slotEmailOnline?.templateText
          .replaceAll('{interview}', messageType)
          .replaceAll('{Interviewlink}', currentProcess?.link)
          .replace('{roleName}', viewRoleDetails?.role?.tittle)
          .replace('{companyName}', viewRoleDetails?.role?.corporate?.name)
          .replace('{date}', moment(data?.date).format('DD/MM/YYYY'))
          .replace('{time}', data?.time)
          .replace('{duration}', currentProcess?.duration + ` mins`)

        let mailObj = {
          to: stdData?.admin?.email,
          subject: slotEmailOnline?.subject.replaceAll(
            '{interview}',
            messageType
          ),
          htmlBody: template,
        }
        dispatch(sendNotificationEmail(mailObj, true))
      }
      if (slotEmailOffline && currentProcess?.mode !== 'EXTERNAL_LINK') {
        let template
        template = slotEmailOffline?.templateText
          .replaceAll('{interview}', messageType)
          .replace('{roleName}', viewRoleDetails?.role?.tittle)
          .replace('{companyName}', viewRoleDetails?.role?.corporate?.name)
          .replace('{date}', moment(data?.date).format('DD/MM/YYYY'))
          .replace('{time}', data?.time)
          .replace('{duration}', currentProcess?.duration + ` mins`)
          .replace('{location}', currentProcess?.location)
        let mailObj = {
          to: stdData?.admin?.email,
          subject: slotEmailOffline?.subject.replaceAll(
            '{interview}',
            messageType
          ),
          htmlBody: template,
        }
        dispatch(sendNotificationEmail(mailObj, true))
      }
      if (slotWhatsappOnline || slotWhatsappOffline) {
        let whatsapp = {
          to: stdData?.admin?.phone_number,
          templateName:
            currentProcess?.mode === 'EXTERNAL_LINK'
              ? 'interview_slot_selected_online'
              : 'interview_slot_selected_offline',
          components: [
            {
              type: 'HEADER',
              parameters: [
                {
                  type: 'IMAGE',
                  image: {
                    link: 'https://drive.google.com/uc?export=view&id=1do69IcSSUj3P6gX202Af8YUF6eCUv5XH',
                  },
                },
              ],
            },
            {
              type: 'BODY',
              index: 0,
              sub_type: 'CATALOG',
              parameters: [
                {
                  type: 'TEXT',
                  text: stdData?.admin?.first_name,
                },
                {
                  type: 'TEXT',
                  text: messageType,
                },
                {
                  type: 'TEXT',
                  text: viewRoleDetails?.role?.tittle,
                },
                {
                  type: 'TEXT',
                  text: viewRoleDetails?.role?.corporate?.name,
                },

                {
                  type: 'TEXT',
                  text: moment(data?.date).format('DD/MM/YYYY'),
                },
                {
                  type: 'TEXT',
                  text: data?.time,
                },
                {
                  type: 'TEXT',
                  text: currentProcess?.duration + ` mins`,
                },
                currentProcess?.mode === 'EXTERNAL_LINK'
                  ? {
                      type: 'TEXT',
                      text: currentProcess?.link,
                    }
                  : {
                      type: 'TEXT',
                      text: currentProcess?.location,
                    },
              ],
            },
          ],
        }
        dispatch(sendNotificationBulkEmailWhatsapp(whatsapp))
      }
      setChangeDate(false)
      getDriveDetails(params.RoleID, params.DriveID)
      getSingleRoleDetails(params.DriveID, params.RoleID)
    }
  }

  const RequestReshedule = async data => {
    setIsModalOpen(true)
    const result = await ResheduleDriveDate(params.DriveID, params.RoleID, data)
    if (result?.status >= 200 && result?.status <= 300) {
      setChangeDate(false)
      getDriveDetails(params.RoleID, params.DriveID)
      getSingleRoleDetails(params.DriveID, params.RoleID)
    }
  }
  const capitalizeOffline = str => {
    const removeSpace = str?.replace('_', ' ')
    const capitalizedString =
      removeSpace?.charAt(0) + removeSpace?.slice(1)?.toLowerCase()
    return capitalizedString
  }
  return (
    <>
      <SectionWrapper column>
        <Row>
          <Col span={18}>
            <TopHeader row spaceBetween alignCenter>
              <LeftSection centerVertically>
                <Link to="/drives">
                  <LeftArrow />
                </Link>
                <SectionName column>
                  <RoutePath from="Drive" on={'Drive Details'} path="/drives" />
                  <RoleNameFlex alignCenter>
                    <RoleNameDiv>Details</RoleNameDiv>
                  </RoleNameFlex>
                </SectionName>
              </LeftSection>
              <Button.Round
                width={'40px'}
                height={'40px'}
                padding={'10px'}
                icon={<ControlIcon />}
              />
            </TopHeader>

            <PaddedDivider />
            {(viewRoleDetails?.role?.driveRoleCandidateMap?.[0]?.drive
              ?.expCandidateDriveMap[0]?.candidateStatus ===
              'RESCHEDULE_REQUESTED' ||
              (viewRoleDetails?.role?.driveRoleCandidateMap?.[0]?.status ===
                'SCHEDULED' &&
                currentProcess?.date?.length > 0 &&
                currentProcess?.interview?.interviewType !== 'ASSESMENT')) && (
              <Flex flexEnd>
                {changeDate && (
                  <div style={{ marginRight: '10px' }}>
                    <Button.Secondary
                      onClick={() => {
                        setChangeDate(false)
                      }}
                      text={'Cancel'}
                      width={'110px'}
                      borderRadius={'15px'}
                    />
                  </div>
                )}
                <Button.Primary
                  onClick={() => {
                    setChangeDate(true)
                  }}
                  text={'Change Date'}
                  width={'110px'}
                  borderRadius={'15px'}
                />
              </Flex>
            )}
            {(viewRoleDetails?.role?.driveRoleCandidateMap?.[0]?.drive
              ?.expCandidateDriveMap[0]?.candidateStatus === 'PENDING' ||
              viewRoleDetails?.role?.driveRoleCandidateMap?.[0]?.drive
                ?.expCandidateDriveMap[0]?.candidateStatus ===
                'RESCHEDULE_REQUESTED' ||
              changeDate) && (
              <PaddingRow>
                <Col span={8}>
                  <Flex centerVertically>
                    {CheckIcon(viewRoleDetails?.role?.corporate?.logo)}

                    <NameAdd column flexStart>
                      <RoleNameDiv>
                        {viewRoleDetails?.role?.corporate?.name}
                      </RoleNameDiv>
                    </NameAdd>
                  </Flex>
                  <PaddedDivider />
                  <CompanyRequest>
                    {viewRoleDetails?.role?.corporate?.name} has requested to
                    schedule a with you! Pick a Date and Time to continue
                  </CompanyRequest>
                  <br></br>
                  <Flex centerVertically>
                    <Avatar size={24} src={<Assignment />} />
                    <NameAdd column flexStart>
                      <StageName>Stage</StageName>
                      <StageType>
                        {viewRoleDetails?.role?.driveRoleCandidateMap?.[0]?.stage}
                      </StageType>
                    </NameAdd>
                  </Flex>
                  <br></br>
                  <Flex centerVertically>
                    <Avatar size={24} src={<AlarmBlue />} />
                    <NameAdd column flexStart>
                      <StageName>Interview Duration</StageName>
                      <StageType>
                        {currentProcess?.duration + ` mins`}
                      </StageType>
                    </NameAdd>
                  </Flex>

                  <br></br>
                  <Flex centerVertically>
                    <Avatar size={24} src={<AutoMode />} />
                    <NameAdd column flexStart>
                      <StageName>Drive Mode</StageName>
                      <StageType>
                        {getDriveMode(
                          viewRoleDetails?.role?.driveRoleCandidateMap?.[0]?.drive
                            ?.driveMode
                        )}
                      </StageType>
                    </NameAdd>
                  </Flex>
                </Col>
                <Col span={16}>
                  {viewRoleDetails?.role?.driveRoleCandidateMap?.[0]?.drive
                    ?.expCandidateDriveMap[0]?.candidateStatus === 'PENDING' ||
                  changeDate ? (
                    <DateAndTimeSelection
                      slotDate={currentProcess?.date}
                      slotTime={currentProcess?.timeRange}
                      selectDriveDate={selectDriveDate}
                      ResheduleDriveDate={ResheduleDriveDate}
                      RequestReshedule={RequestReshedule}
                      studentDetails={studentDetails}
                    />
                  ) : (
                    <YellowBox>
                      <CalendarYellow />
                      <Flex wrap>
                        <BoxText>
                          I have declined these dates and time, and requested
                          corporate again to provide a new set of dates
                        </BoxText>
                      </Flex>
                    </YellowBox>
                  )}
                </Col>
              </PaddingRow>
            )}

            {viewRoleDetails?.role?.driveRoleCandidateMap?.[0]?.drive
              ?.expCandidateDriveMap[0]?.candidateStatus != 'PENDING' &&
              viewRoleDetails?.role?.driveRoleCandidateMap?.[0]?.drive
                ?.expCandidateDriveMap[0]?.candidateStatus !=
                'RESCHEDULE_REQUESTED' &&
              !changeDate && (
                <>
                  <PaddingRow>
                    <LeftAlignCol span={12}>
                      <Flex centerVertically>
                        {CheckIcon(viewRoleDetails?.role?.corporate?.logo)}

                        <NameAdd column flexStart>
                          <Name1>
                            {viewRoleDetails?.role?.corporate?.name}
                          </Name1>
                          <Address>{viewRoleDetails?.role?.tittle}</Address>
                        </NameAdd>
                      </Flex>
                    </LeftAlignCol>
                    <LeftAlignCol span={6}>
                      <NameAdd column flexStart>
                        <Address>Drive Mode</Address>
                        <Name>
                          {getDriveMode(
                            viewRoleDetails?.role?.driveRoleCandidateMap?.[0]
                              ?.drive?.driveMode
                          )}
                        </Name>
                      </NameAdd>
                    </LeftAlignCol>
                    <Col span={6}>
                      <Flex flexEnd>
                        <Button.Secondary
                          onClick={() => setDrawer(true)}
                          text={'View Details'}
                          width={'110px'}
                          borderRadius={'15px'}
                        />
                      </Flex>
                    </Col>
                  </PaddingRow>
                  <Row>
                    <Col span={7}></Col>
                    <Col span={14}>
                      <CalenderCard>
                        <Col span={12}>
                          <Flex centerVertically>
                            <Avatar size={24} src={<Assignment />} />
                            <NameAdd column flexStart>
                              <StageName>Stage</StageName>
                              <StageType>
                                {
                                  viewRoleDetails?.role
                                    ?.driveRoleCandidateMap?.[0]?.stage
                                }
                              </StageType>
                            </NameAdd>
                          </Flex>
                        </Col>
                        <Col span={12}>
                          <Flex centerVertically>
                            <VerticalDivider type="vertical" />
                            <Avatar size={24} src={<AutoMode />} />
                            <NameAdd column flexStart>
                              <StageName>Status</StageName>
                              <StageType>
                                {viewRoleDetails?.role?.driveRoleCandidateMap?.[0]?.status?.toLowerCase()}
                              </StageType>
                            </NameAdd>
                          </Flex>
                        </Col>
                        <Divider />
                        <Col span={12}>
                          <Flex centerVertically>
                            <Avatar size={24} src={<EventBlue />} />
                            <NameAdd column flexStart>
                              <StageName>Date</StageName>
                              {drivesDetail?.candidateInterviewDetails
                                ?.length === 0 ||
                              viewRoleDetails?.role?.driveRoleCandidateMap?.[0]
                                ?.status === 'SHORTLISTED' ? (
                                <div>Not Yet Scheduled</div>
                              ) : currentProcess?.schedualedTime === null ? (
                                <StageType>
                                  {studentDetails?.student?.isExpCandidate
                                    ? moment(
                                        currentProcess
                                          ?.studentInterviewTimeSlotMap?.[0]
                                          ?.selectedDate
                                      ).format('DD/MM/YYYY')
                                    : moment(currentProcess?.date[0]).format(
                                        'DD/MM/YYYY'
                                      )}
                                </StageType>
                              ) : (
                                <StageType>
                                  {studentDetails?.student?.isExpCandidate
                                    ? moment(
                                        currentProcess
                                          ?.studentInterviewTimeSlotMap?.[0]
                                          ?.selectedDate
                                      ).format('DD/MM/YYYY')
                                    : moment(
                                        parseInt(
                                          currentProcess?.schedualedTime?.start
                                        )
                                      ).format('DD MMM , YYYY')}
                                </StageType>
                              )}
                            </NameAdd>
                          </Flex>
                        </Col>
                        <Col span={12}>
                          <Flex centerVertically>
                            <VerticalDivider type="vertical" />
                            <Avatar size={24} src={<AlarmBlue />} />
                            <NameAdd column flexStart>
                              {drivesDetail?.candidateInterviewDetails
                                ?.length === 0 ||
                              viewRoleDetails?.role?.driveRoleCandidateMap?.[0]
                                ?.status === 'SHORTLISTED' ? (
                                <>
                                  <StageName>Time</StageName>
                                  <div>-</div>
                                </>
                              ) : currentProcess?.schedualedTime === null ? (
                                <>
                                  <StageName>Duration</StageName>
                                  <StageType>
                                    {currentProcess?.duration + ` mins`}
                                  </StageType>
                                </>
                              ) : (
                                <>
                                  {studentDetails?.student?.isExpCandidate ? (
                                    <>
                                      <StageName>Time</StageName>
                                      {
                                        currentProcess
                                          ?.studentInterviewTimeSlotMap?.[0]
                                          ?.selectedTime
                                      }
                                      <StageType></StageType>
                                      <StageName>Duration</StageName>
                                      <StageType>
                                        {currentProcess?.duration + ` mins`}
                                      </StageType>
                                    </>
                                  ) : (
                                    <>
                                      {console.log(
                                        currentProcess?.schedualedTime?.start
                                      )}
                                      <StageName>Time</StageName>
                                      <StageType>
                                        {moment(
                                          parseInt(
                                            currentProcess?.schedualedTime
                                              ?.start
                                          )
                                        )
                                          .subtract(5, 'hours')
                                          .subtract(30, 'minutes')
                                          .format('LT')}{' '}
                                        -{' '}
                                        {moment(
                                          parseInt(
                                            currentProcess?.schedualedTime?.end
                                          )
                                        )
                                          .subtract(5, 'hours')
                                          .subtract(30, 'minutes')
                                          .format('LT')}{' '}
                                      </StageType>
                                    </>
                                  )}
                                </>
                              )}
                            </NameAdd>
                          </Flex>
                        </Col>

                        {currentProcess?.mode && (
                          <>
                            <Divider />
                            <StageName padding={'10px'}>
                              <b> Interview Mode: &nbsp; </b>
                              {capitalizeOffline(currentProcess?.mode)}
                            </StageName>
                          </>
                        )}
                        <br></br>
                        {drivesDetail?.candidateInterviewDetails?.length ===
                          0 ||
                        viewRoleDetails?.role?.driveRoleCandidateMap?.[0]
                          ?.status === 'SHORTLISTED' ||
                        viewRoleDetails?.role?.driveRoleCandidateMap?.[0]
                          ?.status === 'SELECTED' ? (
                          <div> </div>
                        ) : currentProcess?.mode === 'OFFLINE' ? (
                          <>
                            <Location width="100%" padding="10px">
                              <b> Interview Location</b>
                            </Location>
                            <Location width="100%">
                              {currentProcess?.location}
                            </Location>
                          </>
                        ) : (
                          <Button.Primary
                            text={'Join The Interview'}
                            onClick={openLink}
                            width={'100%'}
                          />
                        )}
                      </CalenderCard>
                      {currentProcess?.instructions && (
                        <>
                          <InstructionName>Instructions</InstructionName>
                          <Instruct>{currentProcess?.instructions}</Instruct>
                        </>
                      )}
                      <YellowBoxNew>
                        <ControlIcon />
                        <Flex column>
                          <NameNew>
                            Having issue with the above info? Reach out to us
                            via{' '}
                            <a href="mailto:mandate@pluginlive.com">
                              mandate@pluginlive.com
                            </a>
                          </NameNew>
                        </Flex>
                      </YellowBoxNew>
                    </Col>
                    <Col span={3}></Col>
                  </Row>
                </>
              )}
          </Col>
          <Col span={6}>
            <br></br>
            <br></br>
            <StyleLeft>
              <Name1>Interview Stage & Status</Name1>
              <PaddedDivider1 />

              <CustomSteps
                current={completedStep}
                currentStatus={completStedepStatus}
                steps={stepsData1}
              />
            </StyleLeft>
          </Col>
        </Row>
      </SectionWrapper>
      {isModalOpen && (
        <PopupModel
          open={isModalOpen}
          footer={null}
          closable={false}
          width={'590px'}
          bodyStyle={{ height: '590px' }}
        >
          <UploadMsgFlex column center centerVertically>
            <ResultIconDiv>
              <ScheduleinterviewIcon />
            </ResultIconDiv>
            <ResultDiv>Date Requested Successfully</ResultDiv>

            <FileInfoDiv>
              New dates for interview has been requested successfully
            </FileInfoDiv>

            <ButtonDiv>
              <Button.Secondary
                text="Close"
                width="80px"
                height="36px"
                onClick={() => {
                  setIsModalOpen(false)
                }}
              />
            </ButtonDiv>
          </UploadMsgFlex>
        </PopupModel>
      )}
      {drawer && (
        <PreviewDrawer
          drawer={drawer}
          setDrawer={setDrawer}
          viewRoleDetails={viewRoleDetails}
        />
      )}
    </>
  )
}
export default DriveDetails
